import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../assests/logo.svg";
import "./Navbar.css";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const menuButton = useRef(null);
  useEffect(() => { setIsOpen(false); }, [location]);
  useEffect(() => {
    const onEscape = (event) => {
      if (event.key === "Escape" && isOpen) { setIsOpen(false); menuButton.current?.focus(); }
    };
    document.addEventListener("keydown", onEscape);
    return () => document.removeEventListener("keydown", onEscape);
  }, [isOpen]);
  return (
    <header className="site-header">
      <a className="site-skip-link" href="#main-content">Hoppa till innehåll</a>
      <div className="site-container site-nav-bar">
        <Link className="site-brand" to="/" aria-label="THAS Redovisning – startsida"><img src={Logo} alt="" width="70" height="70" /><span>Ekonomi &<br />Redovisning</span></Link>
        <button ref={menuButton} className="site-menu-toggle" type="button" aria-expanded={isOpen} aria-controls="site-navigation" onClick={() => setIsOpen(!isOpen)}>{isOpen ? "Stäng" : "Meny"}<span aria-hidden="true">{isOpen ? "×" : "☰"}</span></button>
        <nav id="site-navigation" className={`site-navigation${isOpen ? " is-open" : ""}`} aria-label="Huvudmeny" onClick={() => setIsOpen(false)}>
          <Link to="/#services">Våra tjänster</Link><Link to="/#priser">Paket & priser</Link><Link to="/#about">Om oss</Link><Link className="site-button site-nav-contact" to="/#contact">Kontakta oss <span aria-hidden="true">↗</span></Link>
        </nav>
      </div>
    </header>
  );
};
export default Navbar;
